<script setup>

import { ref } from 'vue'

const isZoomed = ref(false);
const props = defineProps({
    source: { type: String, default: '' },
    altinfo: { type: String, default: '' },
});

const toggleZoom = () => {
    isZoomed.value = !isZoomed.value;
};

</script>

<template>
    <div class="relative">
        <img
            :class="['w-full rounded-2xl object-cover transition-transform duration-300', { 'cursor-zoom-in': !isZoomed, 'cursor-zoom-out': isZoomed }]"
            :src="source"
            :alt="altinfo"
            @click="toggleZoom"
        />
        <div
            v-if="isZoomed"
            class="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center z-50"
            @click="toggleZoom"
        >
            <img
                class="max-w-full max-h-full rounded-2xl"
                :src="source"
                :alt="altinfo"
            />
        </div>
    </div>
</template>

<style scoped>

</style>
